import { LocaleType } from 'src/modules/common/types'
import icon_c from 'src/images/icon_c.png'
import icon_u from 'src/images/icon_u.png'

export const SUPPOER_LOCALES = [
  {
    name: '简体中文',
    value: LocaleType.ZH_CN,
    icon: '🇨🇳',
    image: icon_c,
  },
  {
    name: 'English',
    value: LocaleType.EN_US,
    icon: '🇺🇸',
    image: icon_u,
  }, 
]

export const NULL = 'null'
export const HOME = '$home'

/// common
export const DATA_OVERVIEW = '$data_overview'
export const LABEL_MARKET = '$label_market'
export const CROWD_MANAGEMENT = '$crowd_management'
export const CROWD_LIST = '$crowd_list'
export const CROWD_ID = '$crowd_id'
export const LOOKALIKE_TOOL = '$lookalike_tool'
export const CONFIGURE_CENTER = '$configure_center'
export const ORDER_TAG = '$order_tag'
export const E_COMMERCE_INSIGHT = '$e_commerce_insight'
export const INQUIRY_MANAGE = '$inquiry_manage'
export const INQUIRY_MANAGE_ORIGIN = '$inquiry_manage_origin'
export const INQUIRY_MANAGE_PUSH= '$inquiry_manage_push'
export const INQUIRY_TASK= '$inquiry_task'
export const ALGORITHM_MODEL = '$algorithm_model'
export const TAG_CONFIG = '$tag_configure'
export const APP_FLOW_QUERY = '$app_flow_query'
export const PROJECT_TAG = '$project_tag'
export const SYNC_CONTROL = '$sync_control'
export const INQUIRY = '$问询API'
export const INQUIRY_NAMAGE = '$问询管理'
export const TAG_PUBLISH = '$tag_publish'
export const REPORT = '$统计报表'
export const REPORT_SEGMENT = '$人群报表'
export const BEHAVIOR_TYPE = '$转换类型'

export const DNA = '$DNA'
export const DMP = '$受众管理'
export const PERSON_LABEL = '$用户标签'
export const FAMILY_LABEL = '$家庭标签'
export const LABEL_STATUS = '$标签状态'
export const PERSON_LABEL_LIST = '$用户标签列表'
export const FAMILY_LABEL_LIST = '$家庭标签列表'


/// crowd-manage
export const ALL = '$all'
export const OVERALL = '$overall'
export const LABEL_CROWD = '$label_crowd'
export const UPLOAD_CROWD = '$upload_crowd'
export const LBS_CROWD = '$lbs_crowd'
export const LBS_BATCH_ADDRESS = '$lbs_batch_address'
export const COMBINE_CROWD = '$combine_crowd'
export const LOOKALIKE_CROWD = '$lookalike_crowd'
export const BIDDEN_CROWD = '$bidden_crowd'
export const ALGORITHM_CROWD = '$algorithm_crowd'
export const THIRDPARTDMP_CROWD = '$thirdpartdmp_crowd'
export const COMPARE_CROWD = '$compare_crowd'


export const MY_CROWD = '$my_crowd'
export const ALL_CROWD = '$all_crowd'

export const ORDER_NUMBER = '$order_number'
export const CROWD_NAME = '$crowd_name'
export const EDIT_FORM_CROWD_NAME = '$edit_form_crowd_name'
export const EDIT_FORM_COMBINE_CONDITION = '$edit_form_combine_condition'
export const EDIT_FORM_DEFAULT_CONDITION = '$edit_form_default_condition'
export const EDIT_FORM_DEFAULT_CONDITION_LAST = '$edit_form_default_condition_last'
export const EDIT_FORM_DEFAULT_CONDITION_NONE = '$edit_form_default_condition_none'

export const COMMIT_DATE = '$commit_date'
export const NO_MORE_THAN_60 = '$no_more_than_60'
export const END_LIMIT_WITH_TODAY = '$end_limit_with_today'
export const CREATE_SUCCESS = '$create_success'
export const PLEASE_INPUT_CROWD_NAME = '$please_input_crowd_name'
export const PLEASE_INPUT_PLACE_NAME = '$please_input_place_name'
export const PLEASE_INPUT_FTP_PATH = '$please_input_ftp_path'
export const AD_EMPLOYER = '$ad_employer'
export const PROJECT = '$project'
export const CHANNEL = '$channel'
export const PLEASE_SELECT_PROJECT = '$please_select_project'
export const PLEASE_SELECT_FILES = '$please_select_files'
export const PLEASE_SELECT_FILE = '$please_select_file'
export const PLEASE_SELECT_TAGS = '$please_select_tags'
export const PLEASE_SELECT_SEGMENTS = '$please_select_segments'
export const PLEASE_SELECT_SEGMENT = '$please_select_segment'
export const PLEASE_SELECT_API = '$please_select_api'
export const PLAN = '$plan'
export const PLEASE_SELECT_PLAN = '$please_select_plan'
export const ORDER = '$order'
export const CREATIVITY = '$creativity'
export const CYCLE = '$cycle'
export const PLEASE_SELECT_CYCLE = '$please_select_cycle'
export const BEHAVIOR_CONDITION = '$behavior_condition'
export const FREQUENCY = '$frequency'
export const UNLIMITED = '$unlimited'
export const MORE_THAN_TWO_TIMES = '$more_than_two_times'
export const MORE_THAN_FIVE_TIMES = '$more_than_five_times'
export const CUSTOM = '$custom'
export const CI_JI_YI_SHANG = '$ci_ji_yi_shang'
export const TERMINAL_TYPE = '$terminal_type'
export const SYSTEM_TYPE = '$system_type'
export const CREATE = '$create'
export const CANCEL = '$cancel'
export const COMBINE_CONDITION = '$combine_condition'
export const COMMIT = '$commit'
export const COMBINE_RESULT = '$combine_result'
export const DATA_NOT_AVAILABLE = '$data_not_available'
export const RESET = '$reset'
export const SEQUENCE = '$sequence'
export const COVERAGE_USER = '$coverage_user'
export const COVERAGE_UPLOAD = '$coverage_upload'
export const TYPE = '$type'
export const MOST_20_PERSON = '$most_20_person'
export const MOST_2_SEGMENT_COMPARE = '$most_2_segment_compare'
export const TOTAL = '$total'
export const PLEASE_UPLOAD_FILE = '$please_upload_file'
export const PLEASE_UPLOAD_EXCEL = '$please_upload_excel'
export const FILE_COUNT_MOST_1 = '$file_count_most_1'
export const ONLY_EXCEL_CSV_TXT = '$only_excel_csv_txt'
export const FILE_SIZE_LESS_THAN_1G = '$file_size_less_than_1G'
export const FILE_SIZE_LESS_THAN_6G = '$file_size_less_than_6G'
export const RANGE_TIP = '$range_tip'
export const UPLOAD_SUCCESS = '$upload_success'
export const CREATE_CROWD = '$create_crowd'
export const EDIT_CROWD = '$edit_crowd'
export const CROWD_DEFINATION = '$Tags for Segement'
export const ADD_TO_SEGMENT = '$add_to_segment'
export const DOWNLOAD_TEMPLATE = '$download_template'
export const FILE_SIZE_ATTENTION = '$file_size_attention'
export const INPUT_TOO_LONG = '$input_too_long'
export const INPUT_TOO_SHORT = '$input_too_short'
export const UPLOAD = '$upload'
export const UPLOAD_FILE = '$upload_file'
export const SELECT_FILE = '$select_file'
export const SUPPORT_CSV_TXT = '$support_csv_txt'
export const SUPPORT_EXCEL_CSV_TXT = '$support_excel_csv_txt'
export const CROWD_FILE_NAME = '$crowd_file_name'
export const ID_TYPE = '$id_type'
export const ID_SIGN = '$id_sign'
export const SELECT_ID_TYPE = '$select_id_type'
export const THIRD_PARTY = '$third_party'
export const THIRD_PARTY_COOKIE = '$third_party_cookie'
export const TOTAL_USER = '$total_user'
export const STATUS = '$status'
export const YOYI_MATCHING_RATIO = '$yoyi_matching_ratio'
export const MAINTAIN_DATE = '$maintain_date'
export const INVALID_DATE = '$invalid_date'
export const CREATOR = '$creator'
export const SEARCH_WITH_CROWD_NAME = '$search_with_crowd_name'
export const PROCESS_FILE_TIME = '$process_file_time'
export const CROWD_NAME_OBSCURE_SEARCH = '$crowd_name_obscure_search'
export const DELAY_SUCCESS = '$delay_success'
export const DELAY = '$delay'
export const CONFIRM = '$confirm'
export const CREATE_TIME = '$create_time'
export const INVALID_TIME = '$invalid_time'
export const SET_DELAY = '$set_delay'
export const DELAY_UNTIL = '$delay_until'
export const SPREAD_SUCCESS = '$spread_success'
export const SPREAD_CROWD = '$spread_crowd'
export const SPREAD = '$spread'
export const CROWD_PACKAGE = '$crowd_package'
export const LOOK_LIKE_NAME = '$look_like_name'
export const PLEASE_INPUT_SPREAD_CROWD_NAME = '$please_input_spread_crowd_name'
export const CROWD_SPREAD_CONDITION = '$crowd_spread_condition'
export const PLEASE_SELECT_SPREAD_CROWD_CONDITION = '$please_select_spread_crowd_condition'
export const ONLY_UNLIMITED_SPREAD_CONDITION = '$only_unlimited_spread_condition'
export const CROWD_SPREAD_TIMES = '$crowd_spread_times'
export const PLEASE_INPUT_SPREAD_TIMES = '$please_input_spread_times'
export const SPREAD_TIMES_1_10 = '$spread_times_1_10'
export const TIMES = '$times'
export const TIMES_ = '$times_'
export const START_LATE_END = '$start_late_end'
export const CAN_NOT_SYNC_WITHOUT_AD_EMPLOYER = '$can_not_sync_without_ad_employer'
export const SYNC_PLUS_SUCCESS = '$sync_plus_success'
export const SYNC_PLATFORM_SUCCESS = '$sync_platform_success'
export const MY_AD_EMPLOYER = '$my_ad_employer'
export const GET_AD_EMPLOYER_FAIL = '$get_ad_employer_fail'
export const SYNC_PLUS = '$sync_plus'
export const SYNC_PLATFORM = '$sync_platform'
export const SYNC_THIRD = '$sync_third'
export const SELECT_AD_EMPLOYER = '$select_ad_employer'
export const PLEASE_SELECT_AD_EMPLOYER = '$please_select_ad_employer'
export const START_TIME = '$start_time'
export const PLEASE_SELECT_START_TIME = '$please_select_start_time'
export const START_DATE = '$start_date'
export const END_TIME = '$end_time'
export const PLEASE_SELECT_END_TIME = '$please_select_end_time'
export const END_DATE = '$end_date'
export const CLEAR = '$clear'
export const START_COMBINE = '$start_combine'
export const START_COMPARE = '$start_compare'
export const CURRENT_STATUS_COUNT = '$current_status_count'
export const CROWD_TOTAL = '$crowd_total'
export const CROWD_TYPE = '$crowd_type'
export const ALL_STATUS = '$all_status'
export const ALL_TYPES = '$all_types'
export const CROWD_PACKAGE_AUTO_UPDATE = '$crowd_package_auto_update'
export const TASK_NO_START_PLEASE_WAIT = '$task_no_start_please_wait'
export const CREATE_CROWD_PACKAGE_PLEASE_WAIT = '$create_crowd_package_please_wait'
export const SYNC_CROWD_PACKAGE_PLEASE_WAIT = '$sync_crowd_package_please_wait'
export const CROWD_PACKAGE_OUTDATE_CAN_NOT_AUTO_UPDATE = '$crowd_package_outdate_can_not_auto_update'
export const MODIFY_AUTO_UPDATE_STATUS = '$modify_auto_update_status'
export const AUTO_UPDATE = '$auto_update'
export const NO_AUTO_UPDATE = '$no_auto_update'
export const UPDATE_SUCCESS = '$update_success'
export const CROWD_PACKAGE_ADDED = '$crowd_package_added'
export const MAKING_CROWD_PACKAGE_PLEASE_WAIT = '$making_crowd_package_please_wait'
export const UNSUPPORTED_COMBINE_WITHOUT_LOOKALIKE = '$unsupported_combine_without_lookalike'
export const UNSUPPORTED_COMBINE_WITHOUT_VALID_CROWD_PACKAGE = '$unsupported_combine_without_valid_crowd_package'
export const UNSUPPORTED_DELAY_WITHOUT_VALID_CROWD_PACKAGE = '$unsupported_delay_without_valid_crowd_package'
export const _DELETE = '$delete'
export const CAN_NOT_DELETE_WHEN_MAKING_CROWD_PACKAGE = '$can_not_delete_when_making_crowd_package'
export const CAN_NOT_DELETE_WHEN_SYNCING_CROWD_PACKAGE = '$can_not_delete_when_syncing_crowd_package'
export const CAN_NOT_DELETE_AFTER_CROWD_PACKAGE_SYNC_PLUS = '$can_not_delete_after_crowd_package_sync_plus'
export const CAN_NOT_DELETE_DMP_CROWD_PACKAGE = '$can_not_delete_dmp_crowd_package'
export const SURE_TO_DELETE_CROWD_XXX = '$sure_to_delete_crowd_xxx'
export const NEW_TYPE_CROWD_WITHOUT_CONFIGURED = '$new_type_crowd_without_configured'
export const DELETE_SUCCESS = '$delete_success'
export const EDIT = '$edit'
export const DOWNLOAD = '$download'
export const COPY = '$copy'
export const CHECK = '$check'
export const CAN_NOT_EDIT_WHEN_SYNCING_CROWD_PACKAGE = '$can_not_edit_when_syncing_crowd_package'
export const CAN_NOT_EDIT_WHEN_CROWD_PACKAGE_SYNCED_PLUS = '$can_not_edit_when_crowd_package_synced_plus'
export const CAN_NOT_EDIT_WITHOUT_VALID_CROWD_PACKAGE = '$can_not_edit_without_valid_crowd_package'
export const CAN_NOT_EDIT_WITH_FUZZY_SEARCH_LBS = '$can_not_edit_with_fuzzy_search_lbs'
export const CROWD_INSIGHT = '$crowd_insight'
export const CROWD_INSIGHT_OVERVIEW = '$crowd_insight_overview'
export const AD_TRAFFIC = '$ad_traffic'
export const CROWD_FLOW_INSIGHT = '$crowd_flow_insight'
export const MAKING_INSIGHT_PLEASE_TRY_LATER = '$making_insight_please_try_later'
export const CAN_NOT_INSIGHT_WITHOUT_VALID_CROWD_PACKAGE = '$can_not_insight_without_valid_crowd_package'
export const PLEASE_SELECT_ID_TYPE = '$please_select_id_type'
export const INSIGHT_MUST_WITH_MORE_THAN_500_PERSON = '$insight_must_with_more_than_500_person'
export const CAN_NOT_SPREAD_WITHOUT_VALID_CROWD_PACKAGE = '$can_not_spread_without_valid_crowd_package'
export const CAN_NOT_SPREAD_CROWD_PACKAGE_500_UNTIL_MILLION = '$can_not_spread_crowd_package_500_until_million'
export const SYNC = '$sync'
export const SYNCING_PLEASE_WAIT = '$syncing_please_wait'
export const SYNCING_CROWD_PACKAGE_PLEASE_WAIT = '$syncing_crowd_package_please_wait'
export const CAN_NOT_SYNC_WITHOUT_VALID_CROWD_PACKAGE = '$can_not_sync_without_valid_crowd_package'
export const NO_MATCHING_CROWD = '$no_matching_crowd'
export const SYNC_SUCCESS = '$sync_success'
export const GO_TO_DATA_CRYSTAL_PLATFORM = '$go_to_data_crystal_platform'
export const ADVANCE = '$advance'
export const NO_VALID_CROWD = '$no_valid_crowd'
export const USED = '$used'
export const CROWD_UPPER_LIMIT = '$crowd_upper_limit'
export const TO_BE_INVALIDATE = '$to_be_invalidate'
export const SELECT_GRANT_CROWD = '$select_grant_crowd'
export const SHOW_TO_AGENT = '$show_to_agent'
export const SHOW_TO_ALL_USER = '$show_to_all_user'
export const AT_LEAST_A_CROWD = '$at_least_a_crowd'
export const ABS_VALUE = '$abs_value'
export const TGI_VALUE = '$tgi_value'
export const CROWD_PACKAGE_PROPORTION = '$crowd_package_proportion'
export const TGI_INDEX = '$tgi_index'
export const CROWD_COUNT = '$crowd_count'
export const POPULATION_ATTRIBUTE = '$population_attribute'
export const CONSUME_SCENE = '$consume_scene'
export const CONSUME_SCENE_SHORT = '$consume_scene_short'
export const ONLINE_CHARACTER = '$online_character'
export const APP_CATEGORY = '$app_category'
export const DISTINGUISH_FEATURE = '$distinguish_feature'
export const GENDER_DISTRIBUTE = '$gender_distribute'
export const AGE_DISTRIBUTE = '$age_distribute'
export const PROGRAM_PREFERENCE = '$program_preference'
export const MEDIA_PREFERENCE = '$media_preference'
export const CONSUME_PREFERENCE = '$consume_preference'
export const SHOPPING_PREFERENCE = '$shopping_preference'
export const SAVE_PAGE_AS_PICTURE = '$save_page_as_picture'
export const INSIGHT_REPORT_DOWNLOAD = '$insight_report_download'
export const PERSONAL_PORTRAY_DOWNLOAD = '$personal_portray_download'
export const ACTIVE_PERSON_RECENT_15_DAYS = '$active_person_recent_15_days'
export const ACTIVE_PERSON_RECENT_30_DAYS = '$active_person_recent_30_days'
export const ACTIVE_PERSON_RECENT_60_DAYS = '$active_person_recent_60_days'
export const SELECT_CONDITION_NONE = '$select_condition_none'
export const SELECT_CONDITION = '$select_condition'
export const LOOKALIKE_SELECT_CONDITION = '$lookalike_definition'
export const SELECT_TIME = '$select_time'
export const SELECTED_RANGE = '$selected_range'
export const ADDRESS = '$address'
export const SPREAD_CONDITION = '$spread_condition'
export const SEED_CROWD_COUNT = '$seed_crowd_count'
export const SPREAD_CROWD_COUNT = '$spread_crowd_count'
export const TO_BE_INVALIDATE_CROWD_PACKAGE_COUNT = '$to_be_invalidate_crowd_package_count'
export const SEARCH_TAG = '$search_tag'
export const MATCH_TAG = '$match_tag'
export const SELECTED_TAG = '$selected_tag'
export const TAG_LIST = '$tag_list'
export const CROWD_IS_CREATING_PLEASE_WAIT = '$crowd_is_creating_please_wait'
export const CONDITION_COMBINE_ERROR = '$condition_combine_error'
export const NAME_LENGTH_NO_MORE_THAN_20 = '$name_length_no_more_than_20'
export const LOOK_COVERAGE_CROWD = '$look_coverage_crowd'
export const SAVE_SUCCESS = '$save_success'
export const SAVE = '$save'
export const PLEASE_INPUT_MATCH_CONTENT = '$please_input_match_content'
export const DEFAULT_CONDITION = '$default_condition'
export const UNMATCHED_TAG = '$unmatched_tag'
export const EXIST_TAG = '$exist_tag'
export const PLEASE_INPUT_SEARCH_CONTENT = '$please_input_search_content'
export const PLEASE_INPUT_SEARCH_CONDITION = '$请输入搜索条件'
export const SEARCH_CONDITION = '$搜索条件'
export const PLEASE_INPUT_TAG_NAME = '$please_input_tag_name'
// 兼容以前人群包
export const AND = '交'
export const OR = '并'
export const NOT = '非'
export const MINUS = '减'
export const LEFT_PARENTHESIS = '('
export const RIGHT_PARENTHESIS = ')'
export const PLEASE_CONFIG_TAG_COMBINE = '$please_config_tag_combine'
export const SQL_START_REQUEST = '$sql_start_request'
export const SQL_NOT_SYMBOL_REQUEST = '$sql_not_symbol_request'
export const SQL_LEFT_BRACKET_REQUEST = '$sql_left_bracket_request'
export const ATTENTION_SYMBOL_SPACE = '$attention_symbol_space'
export const SQL_RIGHT_BRACKET_REQUEST = '$sql_right_bracket_request'
export const CAN_ONLY_END_WITH_RIGHT_BRACKET = '$can_only_end_with_right_bracket'
export const BRACKET_NOT_MATCH = '$bracket_not_match'
export const NOT_SYMBOL_MUST_AFTER_AND_OR = '$not_symbol_must_after_and_or'
export const CREATING = '$creating'
export const SPREADING = '$spreading'
export const PLEASE_SELECT_POSITION = '$please_select_position'
export const PLEASE_SET_DISTANCE_0_5_KM = '$please_set_distance_0_5_km'
export const PLEASE_CONFIRM_DISTANCE_ORDER = '$please_confirm_distance_order'
export const EDIT_CROWD_SUCCESS = '$edit_crowd_success'
export const CREAT_CROWD_SUCCESS = '$creat_crowd_success'
export const EDIT_CROWD_NAME_SUCCESS = '$edit_crowd_name_success'
export const CROWD_NO_UPDATE = '$crowd_no_update'
export const PLEASE_INPUT_NO_MORE_THAN_20_LENGTH_CROWD_NAME = '$please_input_no_more_than_20_length_crowd_name'
export const SELECT_RESULT = '$select_result'
export const NATIONWIDE = '$nationwide'
export const TELEPHONE = '$telephone'
export const NOT_NATCH_LONGITUDE_AND_LATITUDE = '$not_natch_longitude_and_latitude'
export const SEARCH_LONGITUDE_AND_LATITUDE = '$search_longitude_and_latitude'
export const BATCH_SEARCH = '$batch_search'
export const BATCH_SEARCH_SHORT = '$batch_search_short'
export const FILTER_CITY = '$filter_city'
export const CHECK_ALL_THIS_PAGE = '$check_all_this_page'
export const ESTIMATE_PERSON = '$estimate_person'
export const PLEASE_SELECT_SEARCH_RESULT = '$please_select_search_result'
export const PLEASE_INPUT_CORRECT_NUM = '$please_input_correct_num'
export const CUSTOM_RANGE_IN_0_5_KM = '$custom_range_in_0_5_km'
export const START_RANGE_LESS_THAN_END_RANGE = '$start_range_less_than_end_range'
export const CUSTOM_RANGE_CONTAIN_2_DECIMAL = '$custom_range_contain_2_decimal'
export const LBS_NAME = '$lbs_name'
export const BATCH_CREATE = '$batch_create'
export const LBS_QUAN_REN = '$lbs_quan_ren'
export const ENTER_LBS_SEARCH = '$enter_lbs_search'
export const WAIT_LBS_SEARCH_PER_ONE_AND_A_HALF_HOUR = '$wait_lbs_search_per_one_and_a_half_hour'
export const SEED_COUNT = '$种子用户量'

/// label-market
export const SEARCH_INPUT_PLACEHOLDER = '$search_input_placeholder'
export const SEARCH_BUTTON = '$search_button'
export const TAG_EXPLAIN = '$tag_explain'
export const HOT_WORD = '$hot_word'
export const ENTER_CROWD_CONDITION = '$enter_crowd_condition'
export const TAG_NAME = '$tag_name'
export const COVERAGE_YOYI_ID = '$coverage_yoyi_id'
export const COVERAGE_YOYI_HHID = '$coverage_yoyi_hhid'
export const OPERATION = '$operation'
export const PROPORTION = '$proportion'
export const TAG_SEARCH_RESULT = '$tag_search_result'
export const TAG_SEARCH_LABEL = '$tag_search_label'
export const OPERATOR = '$operator'
export const OPERATIONTIME = '$operation_time'


/// data-overview
export const TAG_CLOUD = '$data_overview_tag_cloud'
export const ID_ATLAS = '$data_overview_id_atlas'
export const ID_ATLAS_USER = '$data_overview_id_atlas_user'
export const ID_ATLAS_FAMILY = '$data_overview_id_atlas_family'
export const OVERVIEW_TAG_CLOUD_CHART_INTRO = '$overview_tag_cloud_chart_intro'
export const OVERVIEW_TAG_CLOUD_FAMILY_CHART_INTRO = '$overview_tag_cloud_family_chart_intro'
export const OVERVIEW_ID_MAP_CHART_INTRO = '$overview_id_map_chart_intro'
export const OVERVIEW_ID_MAP_FAMILY_CHART_INTRO = '$overview_id_map_family_chart_intro'
export const OVERVIEW_INDUSTRY_CHART_INTRO = '$overview_industry_chart_intro'
export const OVERVIEW_AVERAGE_CHART_INTRO = '$overview_average_chart_intro'
export const OVERVIEW_AVERAGE_FAMILY_CHART_INTRO = '$overview_average_family_chart_intro'
export const TERRITORY_DISTRIBUTE = '$data_overview_territory_distribute'
export const TAG_DISTRIBUTE = '$data_overview_tag_distribute'
export const INDUSTRY_CROWD = '$data_overview_industry_crowd'
export const BASE_ATTRIBUTE = '$data_overview_base_attribute'
export const BASE_ATTRIBUTE_TOTAL = '$data_overview_base_attribute_total'
export const AVERAGE_TAG_DISTRIBUTE = '$data_overview_average_tag_distribute'
export const AVERAGE_FAMILY_TAG_DISTRIBUTE = '$data_overview_average_family_tag_distribute'
export const INTEREST = '$data_overview_interest'
export const INTEREST_FAMILY = '$data_overview_interest_family'
export const INTEREST_INTERMEDIARY_HABIT = '$data_overview_interest_intermediary_habit'
export const INTEREST_TERMINAL_BRAND = '$data_overview_interest_terminal_brand'
export const RECENT_ID_TREND = '$recent_id_trend'
export const RECENT_HOUSEHOLD_ID_TREND = '$recent_household_id_trend'
export const GENDER = '$gender'
export const AGE = '$age'
export const FEMALE = '$female'
export const MALE = '$male'
export const BASE_INFO = '$base_info'
export const POTENTIAL_CONSUMER_REQUEST = '$potential_consumer_request'
export const HIGH = '$high'
export const LOW = '$low'
export const CHINA = '$china'
export const BASE_SORT = '$base_sort'

export const DIFFUSE_COUNT = '$扩散用户量'
export const SPREAD_TIMES = '$扩散倍数'
export const SEED_CROWD_NAME = '$种子人群名称'
export const CROWD_AUTH = '$人群授权'

export const ABSOLUTE_TIME = '$ABSOLUTE_TIME'
export const RELATIVE_TIME = '$RELATIVE_TIME'

export const PC = '$PC'
export const MOBILE = '$Mobile'
export const OTT = 'OTT'
export const TV = 'TV'
export const IOS = '$iOS'
export const ANDROID = '$Android'
export const YOYI_COOKIE = '$YOYI Cookie'
export const COOKIE = 'Cookie'
export const IDFA_IMEI = 'IDFA & IMEI'
// options
export const STATUS_CREATED = '$Created'
export const STATUS_GENERATING = '$Generating'
export const STATUS_GENERATED = '$Generated'
export const STATUS_SYNCHRONIZING = '$Synchronizing'
export const STATUS_SYNCHRONIZED = '$Synchronized'
export const STATUS_EXPIRED = '$Expired'
export const STATUS_DELETE = '$Delete'
export const STATUS_MATCH_COUNT_LESS = '$match_count_less'

export const LBS_UPLOAD_CREATE_NOTICE = '$注意：文件格式为：店名、地理位置、所在城市'
export const LBS_SEARCH_CREATE_NOTICE = '$注意：如果支持的LBS较多，输出结果可能需要48小时以上，还请谨慎提交并耐心等待'
export const SUPPORT = '$support'

export const LOGOUT = '$Logout'
export const ACCOUNT_MANAGEMENT = '$Account Management'
export const ROLE_MANAGEMENT = '$Role Management'
export const FINANCE_MANAGEMENT = '$Finance Management'
export const MODIFY_PASSWORD = '$Change Password'
export const AGENT_MANAGEMENT = '$Agent'
export const USER_MANAGEMENT = '$Advertisers'
export const DATA_MANAGEMENT = '$Reporting'
export const MORE_FUNCTION = '$more_function'

export const UPPER_BOUND = '$upper_bound'
export const UPPER_QUARTILE = '$upper_quartile'
export const MIDDLE_QUARTILE = '$middle_quartile'
export const LOWER_QUARTILE = '$lower_quartile'
export const LOWER_BOUND = '$lower_bound'
export const AVERAGE = '$average'
export const DEVICE_ORIGIN = '$device_origin'
export const BOXPLOT_OUTLINER_UP_COUNT = '$boxplot_outliner_up_count'
export const BOXPLOT_OUTLINER_UP_RATE = '$boxplot_outliner_up_rate'
export const BOXPLOT_OUTLINER_DOWN_COUNT = '$boxplot_outliner_down_count'
export const BOXPLOT_OUTLINER_DOWN_RATE = '$boxplot_outliner_down_rate'
// echart_name_map
export const BEIJING = '$beijing'
export const TIANJIN = '$tianjin'
export const SHANGHAI = '$shanghai'
export const CHONGQING = '$chongqing'
export const HEBEI = '$hebei'
export const SHANXI = '$shanxi'
export const LIAONING = '$liaoning'
export const JILIN = '$jilin'
export const HEILONGJIANG = '$heilongjiang'
export const JIANGSU = '$jiangsu'
export const ZHEJIANG = '$zhejiang'
export const ANHUI = '$anhui'
export const FUJIAN = '$fujian'
export const JIANGXI = '$jiangxi'
export const SHANDONG = '$shandong'
export const HENAN = '$henan'
export const HUBEI = '$hubei'
export const HUNAN = '$hunan'
export const GUANGDONG = '$guangdong'
export const HAINAN = '$hainan'
export const SICHUAN = '$sichuan'
export const GUIZHOU = '$guizhou'
export const YUNNAN = '$yunnan'
export const SHAANXI = '$shaanxi'
export const GANSU = '$gansu'
export const QINGHAI = '$qinghai'
export const TAIWAN = '$taiwan'
export const NEIMENGGU = '$neimenggu'
export const GUANGXI = '$guangxi'
export const XIZANG = '$xizang'
export const NINGXIA = '$ningxia'
export const XINJIANG = '$xinjiang'
export const XIANGGANG = '$xianggang'
export const AOMEN = '$aomen'
export const TAG_COMBINATION = '$tag_combination'
export const IMPRESSION = '$impression'
export const CLICK = '$click'
export const IMPRESSION_NOT_CLICK = '$impression_not_click'
export const SWITCH_OPEN = '$switch_open'
export const SWITCH_CLOSE = '$switch_close'
export const SWITCH_YES = '$switch_yes'
export const SWITCH_NO = '$switch_no'

export const GENERATE_EACH_LBS_TO_SEGMENT = '$generate_each_lbs_to_segment'
export const LBS_SWITCH_TIP = '$lbs_switch_tip'
export const GENERATE_INSIGHT = '$generate_insight'
export const MATCH_INSIGHT = '$match_insight'
export const UPLOAD_CROWD_NOTE = '$upload_crowd_note'
export const UPLOAD_CROWD_TIP1 = '$upload_crowd_tip1'
export const UPLOAD_CROWD_TIP2 = '$upload_crowd_tip2'
export const UPLOAD_CROWD_TIP3 = '$upload_crowd_tip3'
export const UPLOAD_CROWD_TIP4 = '$upload_crowd_tip4'

export const BIDDEN_CROWD_NOTE = '$bidden_crowd_note'
export const BIDDEN_CROWD_TIP1 = '$bidden_crowd_tip1'
export const BIDDEN_CROWD_TIP2 = '$bidden_crowd_tip2'
export const BIDDEN_CROWD_TIP3 = '$bidden_crowd_tip3'
export const BIDDEN_CROWD_TIP4 = '$bidden_crowd_tip4'
export const BIDDEN_CROWD_TIP5 = '$bidden_crowd_tip5'
export const BIDDEN_CROWD_TIP6 = '$bidden_crowd_tip6'

export const LBS_CROWD_NOTE = '$lbs_crowd_note'
export const LBS_CROWD_TIP1 = '$lbs_crowd_tip1'
export const LBS_CROWD_TIP2 = '$lbs_crowd_tip2'
export const LBS_CROWD_TIP3 = '$lbs_crowd_tip3'
export const LBS_CROWD_TIP4 = '$lbs_crowd_tip4'

export const INQUIRY_CREATE = '$创建问询API'
export const INQUIRY_EDIT = '$编辑问询API'
export const INQUIRY_API_NAME = '$Inquiry API Name'
export const INQUIRY_JAR_PACKAGE_PATH = '$Jar Package Path'
export const INQUIRY_API_DESC = '$API Description'
export const INQUIRY_PLEASE_INPUT_API_NAME = '$请输入API名称'
export const INQUIRY_PLEASE_INPUT_JAR_PACKAGE_PATH = '$请输入JAR包路径'
export const INQUIRY_PLEASE_INPUT_API_DESC = '$请对API支持的功能进行描述'

export const SOURCE_CROWD_TYPE = '$源人群类型'
export const SOURCE_CROWD_PACKAGE = '$源人群包'
export const INQUIRY_2TIMES_PACKAGE = '$2+次问询包'
export const DAILY_INQUIRY_TIME = '$每日问询时间'
export const OCLOCK = '$时'
export const SOURCE_PACKAGE = '$源包'
export const NEW_PACKAGE = '$新包'
export const SOURCE_PACKAGE_NEW_PACKAGE = '$源包+新包'
export const FTP_PATH = '$ftp_path'
export const ORIGIN_SEGMENT_TYPE = '$origin_type'
export const CREATE_MAP_CREATE = '$create_map_create'
export const CREATE_UPLOAD_CREATE = '$create_upload_create'

export const SYNC_PLUS_START_DATE_TIP = '$sync_plus_start_date_tip'
export const SYNC_PLUS_END_DATE_TIP = '$sync_plus_end_date_tip'
export const SYNC_PLUS_SWITCH_TIP = '$sync_plus_switch_date_tip'
export const SYNC_PLATFORM_START_DATE_TIP = '$sync_platform_start_date_tip'
export const SYNC_PLATFORM_END_DATE_TIP = '$sync_platform_end_date_tip'
export const SEGMENT_DOWNLOAD = '$segment_download'
export const SEGMENT_COMPARE = '$segment_compare'
export const CUSTOM_LABEL = '$custom_label'
export const CUSTOM_LABEL_SELF = '$custom_label_self'
export const CUSTOM_LABEL_USER = '$custom_label_user'
export const CUSTOM_LABEL_FAMILY = '$custom_label_family'
export const CROWD_INVALID = '$crowd_invalid'

export const PERSON = '$个人'
export const FAMILY = '$家庭'
export const SEGMENT_PERSON = '$个体人群'
export const SEGMENT_FAMILY = '$家庭群体'
export const BACK_LAST_LEVEL = '$返回上级'

export const FAMILY_INSIGHT_OVERVIEW = '$家庭画像'
export const FAMILY_PROPERTY = '$家庭属性'
export const FAMILY_STRUCTURE = '$家庭结构'
export const FAMILY_AGE = '$成员年龄'
export const TV_BRAND = '$电视品牌'
export const CROSS_NUMBER = '$跨屏数量'

export const RESULT_DOWNLOAD = '$result_download'
export const RESULT_DOWNLOAD_TIP = '$result_download_tip'

export const CROWD_CONVERSE = '$人群转换'
export const CONVERSE_CROWD = '$转换人群'
export const ORIGIN_SEGMENT_NAME ='$源包名称'
export const ORIGIN_SEGMENT_ID_TYPE ='$源包ID类型'
export const NAME = '$名称'
export const SYNC_OVER_TIP = '$同步超过提示'
export const DATA_TYPE = '$数据类型'
export const GEO = '$地理位置'

export const FAMILY_STRUCTURE_SINGLE = '$单身/单独居住'
export const FAMILY_STRUCTURE_COUPLE = '$二人世界'
export const FAMILY_STRUCTURE_CHILDREN = '$育儿家庭'
export const FAMILY_STRUCTURE_THREE = '$三代同堂'
export const FAMILY_GENDER = '$成员性别'

export const USER = '$用户'

export const THIRD_PARTY_INQUIRY = '$third_party_inquiry'
export const PROJECT_MANAGEMENT = '$project_management'
export const DATA_REPORT = '$data_report'
export const INQUIRY_START = '$问询开始'
export const INQUIRY_DOING = '$问询中'
export const INQUIRY_DONE = '$问询完成'

export const DNA_COPY_CROWD = '$DNA复制人群'
export const TRAFFIC_CROWD = '$流量圈人'
export const SPLIT_CROWD = '$人群包拆分'
export const CROWD_EFFECT = '$效果定制人群'
export const ACTIVE_CROWD = '$活动人群'


export const IDFA = '$IDFA'
export const IDFA_MD5 = '$IDFA MD5加密'
export const IMEI = '$IMEI'
export const IMEI_MD5 = '$IMEI MD5加密'
export const ANDROIDID = '$Android ID'
export const ANDROIDID_MD5 = '$Android ID MD5加密'
export const OAID = '$OAID'
export const OAID_MD5 = '$OAID MD5加密'

export const FTP_MANAGE = '$ftp管理'

export const PLATFORM_MANAGE = '$平台管理'

export const CLICK_NOT_CONVERSION = '$CLICK_NOT_CONVERSION'